var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: [_vm.data.componentBaseClassName, _vm.data.componentClassName] },
    [
      _vm.regionsHtml.title
        ? _c("div", {
            class: _vm.data.titleClassName,
            domProps: { innerHTML: _vm._s(_vm.regionsHtml.title) }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.products.length
        ? _c(
            "div",
            { class: _vm.data.productsClassName },
            _vm._l(_vm.products, function(product, index) {
              return _c(
                "BaseLink",
                {
                  key: _vm.data.productsClassName + "-product-" + index,
                  class: _vm.data.imageClassName,
                  attrs: { url: product.link }
                },
                [
                  _c("BaseImage", {
                    attrs: {
                      image: {
                        url: product.image,
                        alt: product.name
                      }
                    },
                    on: {
                      load: function($event) {
                        return _vm.handleImageLoad(product, index)
                      },
                      "image-click": function($event) {
                        return _vm.emitAnalyticsData(product, index)
                      }
                    }
                  })
                ],
                1
              )
            }),
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }